module.exports = __webpack_public_path__ + "img/kommune-1265.b6bf9e3b.svg";